export default "__VITE_ASSET__Tive6LjJ__"